// Translate Firebase error codes to user-friendly Polish messages
export function translateFirebaseError(error: any): string {
  const code = error?.code || ''
  const message = error?.message || ''

  // Common Firebase Auth errors
  switch (code) {
    case 'auth/email-already-in-use':
      return 'Ten adres email jest już używany przez inne konto'
    
    case 'auth/invalid-email':
      return 'Nieprawidłowy adres email'
    
    case 'auth/operation-not-allowed':
      return 'Ta operacja nie jest dozwolona'
    
    case 'auth/weak-password':
      return 'Hasło jest za słabe. Użyj co najmniej 6 znaków'
    
    case 'auth/user-disabled':
      return 'To konto zostało zablokowane'
    
    case 'auth/user-not-found':
      return 'Nie znaleziono użytkownika z tym adresem email'
    
    case 'auth/wrong-password':
      return 'Nieprawidłowe hasło'
    
    case 'auth/invalid-credential':
      return 'Nieprawidłowe dane logowania'
    
    case 'auth/too-many-requests':
      return 'Za dużo prób logowania. Spróbuj ponownie później'
    
    case 'auth/network-request-failed':
      return 'Błąd połączenia z internetem'
    
    case 'auth/popup-closed-by-user':
      return 'Okno logowania zostało zamknięte'
    
    case 'auth/popup-blocked':
      return 'Przeglądarka zablokowała okno logowania'
    
    case 'auth/requires-recent-login':
      return 'Ta operacja wymaga ponownego zalogowania'
    
    case 'auth/credential-already-in-use':
      return 'Te dane logowania są już używane przez inne konto'
    
    default:
      // Remove Firebase prefixes and technical terms
      let cleanMessage = message
        .replace(/Firebase: /g, '')
        .replace(/Error \(auth\/[^)]+\)\.?/g, '')
        .replace(/\(auth\/[^)]+\)/g, '')
        .trim()
      
      // If message is empty or still contains technical terms, provide generic message
      if (!cleanMessage || cleanMessage.includes('auth/') || cleanMessage.includes('Firebase')) {
        return 'Wystąpił nieoczekiwany błąd. Spróbuj ponownie'
      }
      
      return cleanMessage
  }
}